import { AppState } from 'src/app/app.state';
import { Dictionary } from 'src/app/shared/types/dictionary';
import { LoggerService } from '../logger/logger.service';
import { Store } from '@ngrx/store';
import { sendAnalyticsEventAction } from './analytics.actions';
import { validString } from 'src/app/shared/utilities/types.utils';

export class AnalyticsBase {
	/**
	 * An analytics action.
	 */
	private action: string;
	/**
	 * The analytics data.
	 */
	private data: Dictionary<string>;
	/**
	 * Our error prefix
	 */
	private errorPrefix: string;

	/**
	 * Our constructor
	 * @param store The global store
	 * @param logger The logger
	 */
	constructor(private store: Store<AppState>, private logger: LoggerService, componentName: string) {
		this.errorPrefix = `[${componentName}]`;
	}

	/**
	 * Handles parsing the string to set event details.
	 * @example 'login|{method:"autologin"} should be the string you set the directive to. Action, category and label are required.
	 */
	protected setAnalyticsData(eventData: string) {
		this.data = this.action = null;

		if (!validString(eventData)) {
			return;
		}

		const [action, unparsedData] = eventData.split('|');
		if (validString(action)) {
			this.action = action;

			if (!validString(unparsedData)) {
				return;
			}

			try {
				this.data = JSON.parse(unparsedData);
			} catch (err) {
				this.logger.error(`${this.errorPrefix} Unable to parse action (${action}) data: ${err}`);
				this.logger.error(`  unparsed data:`, unparsedData);
			}
		} else {
			this.logger.warn(`${this.errorPrefix} No action provided`);
		}
	}

	/**
	 * Sends the GA event
	 */
	protected sendEvent() {
		const { action, data } = this;
		if (validString(action)) {
			this.store.dispatch(
				sendAnalyticsEventAction({
					action,
					data,
				})
			);
		}
	}
}
